var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.wireframes),function([name, wireframe],i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"6","lg":"4"}},[_c('router-link',{staticClass:"text--primary text-decoration-none",attrs:{"to":{
        name: 'Wireframes',
        params: { wireframe }
      },"rel":"nofollow noopener","target":"_blank"}},[_c('app-figure',{attrs:{"alt":`${name} layout`,"aspect-ratio":16/9,"name":name,"src":`https://cdn.vuetifyjs.com/docs/images/wireframes/${wireframe}.svg`,"outlined":""}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }